import React from 'react';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import styled, { StyleSheetManager } from 'styled-components';
import moment from 'moment';
import { Link } from 'react-router';
// import { StyleSheetManager } from 'styled-components';
import { initLoad } from './actions';
// import Menu from './TournamentSMBMenu';
import { connect } from 'react-redux';
// import { Link, Redirect } from 'react-router';
import SMTeamLogo from '../../../../../widgets/components/sm/views/SMTeamLogo';

// const PANE = styled.div`
//     display: flex;
//     flex-direction: column;
//     position: relative;
// `;

const Content = styled.div`
    flex-grow: 1;
    padding: 15px 0px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-weight: 300;
    }
`;

const HighButton = ({ name, sub, active, live }) => (
    <rmd.FlatButton
        style={{
            height: 'auto',
            padding: '5px 15px',
            lineHeight: '24px',
            position: 'relative'
        }}
        primary={active}
    >
        {live && (
            <span
                style={{
                    position: 'absolute',
                    left: 5,
                    top: 14,
                    width: 5,
                    height: 5,
                    borderRadius: 50,
                    background: 'green'
                }}
            />
        )}
        <span>{name}</span>
        <br />
        <sm style={{ fontSize: '11px' }}>{sub}</sm>
    </rmd.FlatButton>
);

class TeamList extends React.Component {
    static defaultProps = {
        limit: 32
    };

    state = { expanded: false };

    render = () => {
        const { expanded } = this.state;
        const { teams = [], limit, link = '' } = this.props;

        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', margin: '10px 0' }}>
                {_.take(teams, expanded ? teams.length : limit).map(t => (
                    <rmd.IconButton
                        key={t.id}
                        tooltip={t.name}
                        tooltipPosition="top-center"
                        style={{ width: 56, height: 56 }}
                    >
                        <Link to={`${link}/team/${t.id}`}>
                            <SMTeamLogo width={32} style={{ marginRight: 10 }} teamId={t.id} />
                        </Link>
                    </rmd.IconButton>
                ))}
                {teams.length > limit &&
                    !expanded && (
                        <rmd.FlatButton
                            label={`See all (${teams.length})`}
                            onClick={() => this.setState({ expanded: true })}
                        />
                    )}
            </div>
        );
    };
}

const TeamListE = connect(state => ({ teams: _.get(state, 'smBrowser.teams', []) }))(TeamList);

class TournamentSMBrowser extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {
        const {
            dispatch,
            params: { tournamentId, seasonId },
            initLoad
        } = this.props;
        dispatch(initLoad(tournamentId, seasonId));
    };

    componentWillReceiveProps = nextProps => {
        const {
            params: { tournamentId, seasonId },
            initLoad,
            dispatch
        } = nextProps;

        const tournamentWasChanged = +this.props.params.tournamentId !== +tournamentId;
        const seasonWasChanged = this.props.params.seasonId + '' !== seasonId + '';

        if (tournamentWasChanged || seasonWasChanged) {
            dispatch(initLoad(tournamentId, seasonId));
        }
    };

    static contextTypes = {
        user: PropTypes.object.isRequired,
        campaigns: PropTypes.array.isRequired,
        router: PropTypes.object.isRequired
    };

    render() {
        const {
            tournament,
            season,
            router,
            params
            // location
        } = this.props;

        const dd = document.getElementById('hostforstylemanager');

        if (!dd) return <div />;

        return (
            <StyleSheetManager target={dd}>
                {/* <PANE onClick={this.handlePaneClick}> */}

                {/* <Menu tournament={tournament} /> */}
                <Content>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <h1 style={{ flexGrow: 1 }}>
                                <Link to={`/sm/browser/${params.sport}/tournaments/${params.tournamentId}`}>
                                    {`${(tournament && tournament.name) || RCore.nbsp} ${(season && season.year) ||
                                        RCore.nbsp}`}
                                </Link>
                            </h1>

                            <rmd.SelectField
                                value={season && season.id}
                                style={{ width: 'auto' }}
                                onChange={(event, index, seasonId) => {
                                    router.push(
                                        `/sm/browser/${params.sport}/tournaments/${params.tournamentId}/${seasonId}`
                                    );
                                }}
                            >
                                {tournament &&
                                    _.sortBy(tournament.seasons, s => -s.id).map(season => (
                                        <rmd.MenuItem key={season.id} value={season.id} primaryText={season.year} />
                                    ))}
                            </rmd.SelectField>
                        </div>
                        <TeamListE link={`/sm/browser/football/tournaments/${tournament.id}/${season.id}`} />
                        {/* <TeamListE link={location.pathname} /> */}
                        <div>
                            {season && (
                                <div>
                                    <Link to={`/sm/browser/football/tournaments/${tournament.id}/${season.id}`}>
                                        <HighButton active={!params.stageId} name="Season overview" sub={season.year} />
                                    </Link>

                                    {season.stages.length > 0 &&
                                        season.stages.map(stage => {
                                            {
                                                /* const currentRound =
                                                _.find(stage.roundsList, r => r.isCurrent) || _.last(stage.roundsList); */
                                            }
                                            const dates = `${moment(stage.startDate).format('D MMM')} - ${moment(
                                                stage.endDate
                                            ).format('D MMM')}`;
                                            const live =
                                                moment().isAfter(stage.startDate) && moment().isBefore(stage.endDate);
                                            return (
                                                <Link
                                                    key={stage.id}
                                                    to={`/sm/browser/football/tournaments/${tournament.id}/${
                                                        season.id
                                                    }/stages/${stage.id}`}
                                                >
                                                    <HighButton
                                                        live={live}
                                                        active={+params.stageId === stage.id}
                                                        name={stage.name}
                                                        sub={dates}
                                                    />
                                                </Link>
                                            );
                                        })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div>{this.props.children}</div>
                </Content>
                {/* </PANE> */}
            </StyleSheetManager>
        );
    }
}

function mapStateToProps(state) {
    // const {
    //     router: {
    //         params: { tournamentId, seasonId }
    //     }
    // } = props;

    return {
        ...state.smBrowser
    };
}

export default connect(
    mapStateToProps,
    dispatch => ({
        dispatch,
        initLoad
    })
)(TournamentSMBrowser);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TournamentSMBrowser.js
 **/